import DefaultRequest from "../api/DefaultRequest";

class RouteDivisionOrders {
  entityName = "RouteDivisionOrders";
  fieldsToNotAddPrefix = [
    "stop.location.description",
    "stop.location.key",
    "route.key",
    "route.date",
    "route.organization",
    "stop.stopDocuments.documentNumber",
  ];

  constructor() {
    const options = Monet.Grid.Utils.paginationOptions;

    if (!App.Forms.RouteDivisionOrders) {
      App.Forms.RouteDivisionOrders = {
        layout: {},
        dataMapper: null,
        pagination: {
          first: options.FIRST,
          max: options.MAX_RESULT,
          blocked: false,
          canIncrement: true,
        },
        stop: null,
        columnToOrders: [],
      };
    }

    if (!App.Objects.RouteDivisionOrders) {
      App.Objects.RouteDivisionOrders = this;
    }
  }

  getFieldsToGridLayout = (callback) => {
    try {
      const ajax = new Monet.Ajax();
      ajax.url = "form/RouteDivisionOrders/index";
      ajax.success = (data) => {
        if (data) {
          App.Forms.RouteDivisionOrders.layout["index"] = data;
        }
        if (callback) {
          callback();
        }
      };

      ajax.error = (response) => {
        Monet.Configurations.errorNotification(null, response);
      };

      ajax.send();
    } catch (e) {
      new Monet.Exception.ReturnError(
        this,
        "Error on get grid layout on route divisiou orders route"
      ).console();
    }
  };

  proccessBody = () => {
    const fields = App.Forms.RouteDivisionOrders.filterBuilder.fields;
    const routeOrganizationId = fields?.['route.organization']?.getValue()?.id;
    const documentNumber = fields?.['stop.stopDocuments.documentNumber']?.getValue();
    const orderNumber = fields?.['number']?.getValue();
    const completeStopCheckbox = document.querySelector('#Route #routeDivisionModalWrapper #buttonEventCheckBox');
    const returnCompleteStop = completeStopCheckbox?.checked;

    return {
      organizationID: routeOrganizationId ? Number(routeOrganizationId) : "",
      documentNumber: documentNumber ? documentNumber : "",
      orderNumber: orderNumber ? orderNumber : "",
      returnCompleteStop,
    }
  }

  updateGrid = (callback, appendCollection) => {
    const addPaginationGrid = true;
    const that = this;

    try {
      const columns = App.Forms.RouteDivisionOrders.table.getColumns();
      const orders = new App.Collections.Orders();
      const filter = App.Forms.RouteDivisionOrders.filterBuilder;

      if (appendCollection) {
        orders.reset();
      }

      filter.filterButton.showLoading();
      App.Forms.RouteDivisionOrders.pagination.blocked = true;

      const request = new DefaultRequest({
        method: 'POST',
        url: "Stop/CrossDocking",
        data: this.proccessBody(),
        success: (response) => {
          response.forEach((dataItem) => {
            let item = dataItem;
            let tooManyItems = orders.extractToManyRelationship(item, "orders");

            if (tooManyItems) {
              tooManyItems.forEach((tooManyItem) => {
                const model = new orders.model();
                let stopDocumentsString;

                const notlinkedStopDocuments = item.stopDocuments.filter((stopDocument) => {
                  const hasOrder = stopDocument?.order;

                  if(!hasOrder) {
                    return true;
                  }
                });

                const linkedStopDocuments = item.stopDocuments.filter((stopDocument) => {
                  const orderId = tooManyItem.id;
                  const orderDocumentNumber = stopDocument?.order?.id;
                  const hasOrderLink = orderDocumentNumber === orderId;

                  if(hasOrderLink) {
                    return true;
                  }
                });

                const parseStopDocuments = (acc, {documentNumber}, index, array) => {
                  const parsedAccumulator = String(acc);

                  if (index === array.length - 1) {
                    return parsedAccumulator.concat(documentNumber);
                  }

                  return parsedAccumulator.concat(`${documentNumber}, `);
                }

                if(linkedStopDocuments.length) {
                  if(linkedStopDocuments.length === 1) {
                    const documentNumber = linkedStopDocuments[0].documentNumber

                    stopDocumentsString = documentNumber;
                  } else {
                    stopDocumentsString = linkedStopDocuments.reduce(parseStopDocuments, '')
                  }
                } else {
                  stopDocumentsString = notlinkedStopDocuments.reduce(parseStopDocuments, '')
                }

                model.set({
                  ...tooManyItem,
                  stop: {
                    id: item.id,
                    location: item.location,
                    stopDocuments: {
                      documentNumber: stopDocumentsString
                    }
                  },
                  route: {
                    ...item.route
                  }
                });

                orders.add(model);
              });
            }
          });

          if (callback) {
            callback(that.entityName, columns, orders, addPaginationGrid);
          }

          filter.loading.hide();
          filter.filterButton.hideLoading();
          App.Forms.RouteDivisionOrders.pagination.blocked = false;
        },
        error: (response) => {
          filter.loading.hide();
          filter.filterButton.hideLoading();
          App.Forms.RouteDivisionOrders.pagination.blocked = false;
          Monet.Configurations.errorNotification(null, response);
        }
      })

      request.send();
    } catch (e) {
      const error = new Monet.Exception.ReturnError(
        this,
        "Error on update route monitoring route",
        e
      );

      error.console();
    }
  };
}
App.Routers.RouteDivisionOrders = RouteDivisionOrders;
